// src/modules/app-views/welcome/pages/Init/modals/FirstSubscriptionModal/Step2.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Alert } from 'antd';
import { AppstoreOutlined } from '@ant-design/icons';
import ResourcesCard from 'modules/app-views/account/pages/Subscription/tabs/RecordTab/ResourcesCard';
import translateX from 'utils/translateX';
import appService from 'services/appService';
import app from 'configs/appResolver';

// *******************************************************************************
// STEP CONTENT COMPONENT
// *******************************************************************************
const Step2Content = ({ state, setState }) => {
  const handleResourcesChange = resources => {
    setState(prev => ({ ...prev, resources }));
  };

  return (
    <div style={{ paddingTop: 8 }}>
      {/* Info message */}
      <Alert
        type="info"
        showIcon
        icon={<AppstoreOutlined />}
        style={{ marginBottom: 16 }}
        title={translateX('resources')}
        description={translateX('select_resources_description')}
      />

      {/* Resources selection */}
      <ResourcesCard
        value={state.resources || []}
        onChange={handleResourcesChange}
        disabled={app.PRESET?.CAN_CHANGE_RESOURCES === false}
        nativeResources={app.PRESET?.NATIVE_RESOURCES}
        colMd={6}
      />
    </div>
  );
};

// *******************************************************************************
// STEP CONFIGURATION
// *******************************************************************************
const stepResources = ({ state, setState }) => ({
  stepTitle: 'resources',
  stepTooltip: 'select_at_least_one_resource',
  hidden: app.PRESET?.SHOW_RESOURCES_FIRST_CONFIGURATION === false,
  content: () => <Step2Content state={state} setState={setState} />,
  onNext: async () => {
    if (!state.resources?.length) {
      appService.notification({
        flag: 'warning',
        title: 'attention',
        description: 'at_least_one_resource_required',
      });
      return false;
    }
    return true;
  },
});

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default stepResources;
